import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import {handleError} from "../../../helpers/handleError";
import eventBus from "../../../event-bus/eventBus";
import router from "../../../../router";

const saveClientPerson = {
    namespaced: true,
    state: {
        typeInfoPersonSave: "",
        headInfoPersonSave: "",
        isPersonSave: false,
        textInfoPersonSave: "",
        dataSavePersonIsFetching: true,
        layout: "",
        clientData: [],
        clientId: 0,
        isSuccessSaveClientModalVisible: false,
        successSaveClientModalData: {}
    },
    mutations: {
        DATA_SAVE_SUCCESS(state, response) {  
            state.successSaveClientModalData.message = response.data.message
            state.successSaveClientModalData.textInfo =  response.data.data.textInfo;
            state.dataSavePersonIsFetching = false;
            if(state.layout === "projectForm" || state.layout === "offerForm") {
                eventBus.$emit("saveClientSuccessProject", state.clientId)
                eventBus.$emit("storeClientSuccess", state.clientId, response.data);
            } else {
                router.push({path: '/clients'});
                state.isSuccessSaveClientModalVisible = true;
            }
            
        },
        DATA_SAVE_FAILURE(state, error) {
            let textInfoPersonSave = state.textInfoPersonSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            let typeInfoPersonSave = state.typeInfoPersonSave = "red";
            let headInfoPersonSave = state.headInfoPersonSave = error.response.data.message;
            let isPersonSave = state.isPersonSave = true;
            state.dataSavePersonIsFetching = false;
            let modalData = { creds: { textInfoPersonSave, typeInfoPersonSave, headInfoPersonSave, isPersonSave } };
            eventBus.$emit("showFailurePerson", modalData.creds)
            eventBus.$emit("saveClientFailure", error.response.data.errors, true);
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isPersonSave = value;
        },
        UPDATE_VISIBLE_SAVE_CLIENT_MODAL(state, value) {
            state.isSuccessSaveClientModalVisible = value;
        }
    },
    actions: {
        saveClientPerson: function({ dispatch, state }, payload) {
            state.clientData = payload.creds.data;
            var promise = sendRequest("post", config.baseURLApi + "/client-persons/" + payload.creds.client_id, {}, payload.creds);
            state.layout = payload.creds.layout;
            state.clientId = payload.creds.client_id;
            promise.then((result) =>  {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
            });
        },
        updateVisibleSuccessSaveClientModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_SAVE_CLIENT_MODAL", value);
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        updateVisibleModalPerson: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        }
    }
}

export default saveClientPerson;